/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from 'relay-runtime';
declare export opaque type emptyState_viewer$ref: FragmentReference;
export type emptyState_viewer = {|
  +home_page: ?{|
    +featured_artist_tracks: ?$ReadOnlyArray<?{|
      +id: string,
      +title: ?string,
      +slug: ?string,
      +price: ?number,
      +assets: ?$ReadOnlyArray<?{|
        +id: string,
        +version: ?string,
        +type: ?string,
        +file_format: ?string,
        +path: ?string,
        +metadata: ?any,
      |}>,
      +artist: ?{|
        +name: ?string,
        +slug: ?string,
        +bio: ?string,
        +assets: ?$ReadOnlyArray<?{|
          +id: string,
          +version: ?string,
          +type: ?string,
          +file_format: ?string,
          +path: ?string,
          +metadata: ?any,
        |}>,
      |},
      +terms: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +is_highlighted: ?boolean,
            +name: ?string,
            +parent_id: ?string,
            +taxonomy: ?{|
              +id: string,
              +name: ?string,
            |},
          |},
        |}>,
      |},
    |}>,
    +featured_collections: ?$ReadOnlyArray<?{|
      +id: string,
      +description: ?string,
      +name: string,
      +slug: ?string,
      +category: ?{|
        +id: string,
        +name: ?string,
      |},
      +assets: ?$ReadOnlyArray<?{|
        +id: string,
        +version: ?string,
        +type: ?string,
        +file_format: ?string,
        +path: ?string,
        +metadata: ?any,
      |}>,
    |}>,
    +featured_tracks: ?$ReadOnlyArray<?{|
      +id: string,
      +title: ?string,
      +slug: ?string,
      +price: ?number,
      +assets: ?$ReadOnlyArray<?{|
        +id: string,
        +version: ?string,
        +type: ?string,
        +file_format: ?string,
        +path: ?string,
        +metadata: ?any,
      |}>,
      +artist: ?{|
        +name: ?string,
        +slug: ?string,
        +assets: ?$ReadOnlyArray<?{|
          +id: string,
          +version: ?string,
          +type: ?string,
          +file_format: ?string,
          +path: ?string,
          +metadata: ?any,
        |}>,
      |},
      +terms: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +is_highlighted: ?boolean,
            +name: ?string,
            +parent_id: ?string,
            +taxonomy: ?{|
              +id: string,
              +name: ?string,
            |},
          |},
        |}>,
      |},
    |}>,
    +featured_terms: ?$ReadOnlyArray<?{|
      +name: ?string,
      +items: ?$ReadOnlyArray<?{|
        +id?: string,
        +is_highlighted?: ?boolean,
        +name?: ?string,
        +parent_id?: ?string,
        +taxonomy?: ?{|
          +id: string,
          +internal_id: ?number,
          +name: ?string,
        |},
        +title?: string,
        +url?: string,
      |}>,
    |}>,
    +header_posts: ?$ReadOnlyArray<?{|
      +title: string,
      +subtitle: string,
      +post_url: string,
      +image_url: string,
    |}>,
    +blog_posts: ?$ReadOnlyArray<?{|
      +title: string,
      +excerpt: string,
      +author: string,
      +post_url: string,
      +image_url: string,
    |}>,
  |},
  +$refType: emptyState_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "price",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "assets",
  "storageKey": null,
  "args": null,
  "concreteType": "Asset",
  "plural": true,
  "selections": [
    v0,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "version",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "type",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "file_format",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    }
  ]
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "is_highlighted",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "parent_id",
  "args": null,
  "storageKey": null
},
v8 = [
  v0,
  v5
],
v9 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "terms",
  "storageKey": null,
  "args": null,
  "concreteType": "TaxonomyTermConnection",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "TaxonomyTermEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "TaxonomyTerm",
          "plural": false,
          "selections": [
            v0,
            v6,
            v5,
            v7,
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "taxonomy",
              "storageKey": null,
              "args": null,
              "concreteType": "Taxonomy",
              "plural": false,
              "selections": v8
            }
          ]
        }
      ]
    }
  ]
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "post_url",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "image_url",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "emptyState_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "license_params",
      "type": "[LicenseUsageParamsInput]"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "home_page",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "license_params",
          "variableName": "license_params",
          "type": "[LicenseUsageParamsInput]"
        }
      ],
      "concreteType": "HomePageContent",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "featured_artist_tracks",
          "storageKey": null,
          "args": null,
          "concreteType": "TrackSearchResult",
          "plural": true,
          "selections": [
            v0,
            v1,
            v2,
            v3,
            v4,
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "artist",
              "storageKey": null,
              "args": null,
              "concreteType": "Artist",
              "plural": false,
              "selections": [
                v5,
                v2,
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "bio",
                  "args": null,
                  "storageKey": null
                },
                v4
              ]
            },
            v9
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "featured_collections",
          "storageKey": null,
          "args": null,
          "concreteType": "Collection",
          "plural": true,
          "selections": [
            v0,
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "description",
              "args": null,
              "storageKey": null
            },
            v5,
            v2,
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "category",
              "storageKey": null,
              "args": null,
              "concreteType": "CollectionCategory",
              "plural": false,
              "selections": v8
            },
            v4
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "featured_tracks",
          "storageKey": null,
          "args": null,
          "concreteType": "TrackSearchResult",
          "plural": true,
          "selections": [
            v0,
            v1,
            v2,
            v3,
            v4,
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "artist",
              "storageKey": null,
              "args": null,
              "concreteType": "Artist",
              "plural": false,
              "selections": [
                v5,
                v2,
                v4
              ]
            },
            v9
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "featured_terms",
          "storageKey": null,
          "args": null,
          "concreteType": "HomePageFeaturedTermsList",
          "plural": true,
          "selections": [
            v5,
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "items",
              "storageKey": null,
              "args": null,
              "concreteType": null,
              "plural": true,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "type": "HomePageLink",
                  "selections": [
                    v1,
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "url",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                },
                {
                  "kind": "InlineFragment",
                  "type": "TaxonomyTerm",
                  "selections": [
                    v0,
                    v6,
                    v5,
                    v7,
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "taxonomy",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "Taxonomy",
                      "plural": false,
                      "selections": [
                        v0,
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "internal_id",
                          "args": null,
                          "storageKey": null
                        },
                        v5
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "header_posts",
          "storageKey": null,
          "args": null,
          "concreteType": "HomePagePost",
          "plural": true,
          "selections": [
            v1,
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "subtitle",
              "args": null,
              "storageKey": null
            },
            v10,
            v11
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "blog_posts",
          "storageKey": null,
          "args": null,
          "concreteType": "BlogPost",
          "plural": true,
          "selections": [
            v1,
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "excerpt",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "author",
              "args": null,
              "storageKey": null
            },
            v10,
            v11
          ]
        }
      ]
    }
  ]
};
})();
(node/*: any*/).hash = '0403861f11becf0652c09e458b0a05d6';
module.exports = node;



// WEBPACK FOOTER //
// ./src/public/relay/__generated__/emptyState_viewer.graphql.js